import Tooltip from "components/Tooltip";
import React from "react";
import styles from "./styles.module.scss";

type PartnerSelectorHandleProps = {
  onTriggerPartnerSelect: () => void;
  selectedPartnerLabel: string;
};

const PartnerSelectorHandle: React.FC<PartnerSelectorHandleProps> = ({
  onTriggerPartnerSelect,
  selectedPartnerLabel,
}) => (
  <Tooltip title={`Law Firm: ${selectedPartnerLabel}, click to change`}>
    <div
      onClick={onTriggerPartnerSelect}
      className={styles["partner-select-handle"]}
      data-tid="header-partner-select-handle"
    >
      <span>{selectedPartnerLabel}</span>
    </div>
  </Tooltip>
);

export default PartnerSelectorHandle;
